import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    BulkOverwriteDialogInput,
    BulkOverwriteDialogResult,
    BulkOverwriteFieldKey,
    BulkOverwriteFieldStat,
    BulkOverwriteMode,
    animalHasFieldValue,
    buildBulkOverwriteFieldStats,
    getAnimalFieldValue,
} from './gruppe-tier-bulk-overwrite-dialog';

@Component({
    selector: 'kiene-gruppe-tier-bulk-overwrite-dialog',
    templateUrl: './gruppe-tier-bulk-overwrite-dialog.component.html',
    styleUrls: ['./gruppe-tier-bulk-overwrite-dialog.component.scss'],
})
export class GruppeTierBulkOverwriteDialogComponent {
    readonly stats: BulkOverwriteFieldStat[];
    showAnimalList = false;

    readonly displayColumns: Array<{ key: BulkOverwriteFieldKey | 'ohrmarke'; label: string }> = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: BulkOverwriteDialogInput,
        private readonly dialogRef: MatDialogRef<
            GruppeTierBulkOverwriteDialogComponent,
            BulkOverwriteDialogResult | undefined
        >,
    ) {
        this.stats = buildBulkOverwriteFieldStats(data?.animals ?? [], data?.fields ?? []);
        this.displayColumns = [
            { key: 'ohrmarke', label: 'Ohrmarke' },
            ...this.stats.map(s => ({ key: s.key, label: s.label })),
        ];
    }

    get canChooseEmptyOnly(): boolean {
        return this.stats.some(s => s.empty > 0 && s.perTierEmptyOnly != null && s.perTierEmptyOnly > 0);
    }

    formatCell(animal: BulkOverwriteDialogInput['animals'][0], key: BulkOverwriteFieldKey | 'ohrmarke'): string {
        if (key === 'ohrmarke') {
            return animal.ohrmarke || '–';
        }
        if (!animalHasFieldValue(animal, key)) {
            return './.';
        }
        const v = getAnimalFieldValue(animal, key);
        if (v == null) {
            return './.';
        }
        if (key === 'abgangsgewicht' || key === 'einstallgewicht') {
            return `${this.formatNumber(v)} kg`;
        }
        return `${this.formatNumber(v)} €`;
    }

    formatValue(v: number | null | undefined, unit?: string): string {
        if (v == null || Number.isNaN(Number(v))) {
            return '–';
        }
        return `${this.formatNumber(Number(v))}${unit ? ' ' + unit : ''}`;
    }

    cancel(): void {
        this.dialogRef.close(undefined);
    }

    choose(mode: BulkOverwriteMode): void {
        if (mode === 'empty_only' && !this.canChooseEmptyOnly) {
            return;
        }
        this.dialogRef.close({ mode });
    }

    private formatNumber(v: number): string {
        return new Intl.NumberFormat('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        }).format(v);
    }
}
